import http, { url } from '../../http'

const API_URL = "epp"

class eppAPI {

  async save(epp) { 
    const response = await http(`${API_URL}/save`, 'POST', epp)
    return response
  }

  async getAllEpp(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  } 
  async getAllEppPage(companiesID, page) {
    const response = await http(`${API_URL}/${companiesID} ?page=${page}`, 'POST', {
      page: page
    })
    return response || null
  }
 

  async getEpp(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateEpp(id, epp) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', epp)
    return response
  }
 
}

export default new eppAPI()